import { formatCalendarDate, formatEasternDate } from 'helpers/dates'

type DatedPrepayment = {
  paymentDate?: string | Date | null
  checkDate?: string | Date | null
  createdAt?: string | Date | null
}

// The date a prepayment shows. Payment and check dates are calendar days the
// biller typed (date columns, which reach the page as UTC midnight), so they
// read by that day; read as an Eastern moment, 05/03 showed as 05/02. Only the
// fallback, when the prepayment was recorded (Stripe), is a moment.
export const formatPrepaymentDate = ({ paymentDate, checkDate, createdAt }: DatedPrepayment): string => {
  const day = paymentDate || checkDate

  return day ? formatCalendarDate(day, '--') : formatEasternDate(createdAt, '--')
}
